<template>
  <el-dialog
    v-model="formVisible"
    title="告警详情"
    @close="close"
    width="40%">
    <el-form
      ref="ruleFormRef"
      :model="ruleForm"
      :rules="rules"
      :disabled="isDisabled"
      label-width="120px"
      class="userForm"
    >
      <div class="formTitle"><span></span>告警信息</div>
      <el-row>
        <el-col :span="12">
          <el-form-item label="告警等级" prop="">
            <el-input
            v-model="ruleForm.name"
              placeholder="告警等级"
              :disabled='true'
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="告警类型" prop="">
            <el-input
            v-model="ruleForm.name"
              placeholder="告警类型"
              :disabled='true'
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="告警时间" prop="">
            <el-input
            v-model="ruleForm.name"
              placeholder="告警时间"
              :disabled='true'
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="告警源类型" prop="">
            <el-input
            v-model="ruleForm.name"
              placeholder="告警源类型"
              :disabled='true'
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="告警设备" prop="">
            <el-input
            v-model="ruleForm.name"
              placeholder="告警设备"
              :disabled='true'
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="告警标题" prop="">
            <el-input
            v-model="ruleForm.name"
              placeholder="告警标题"
              :disabled='true'
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="告警地点" prop="">
            <el-input
            v-model="ruleForm.name"
              placeholder="告警地点"
              :disabled='true'
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="formTitle"><span></span>联动信息</div>
      <el-row>
        <el-col :span="24">
          <el-form-item label="处理意见" prop="">
            <el-input
            v-model="ruleForm.name"
              placeholder="处理意见"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <template v-if="!isDisabled">
        <h-button type="primary" @click="submitForm(ruleFormRef)">处理</h-button>
        <h-button @click="formVisible = false">取消</h-button>
      </template>
    </template>
  </el-dialog>
</template>
<script >
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  computed,
  ref
} from 'vue';
import util from '@util/js';
import { saveQuery, updateQuery } from "@/api/realPopulation/realPopulation";
import { ElMessage } from 'element-plus';
import _ from 'lodash';
export default defineComponent({
  name: '',
  components: {},
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => ({})
    },
    status: {
      type: Number,
      default: 1 // 1 添加；2 编辑；3 只读
    }
  },
  emits: ['update:modelValue', 'submit'],
  setup(props, context) {
    const ruleFormRef = ref();
    // const validate = new Validate(ruleFormRef.value);
    const state = reactive({
      formVisible: false,
      ruleForm: {
        nationality: "",
        name: ''
      },
      ruleFormBack: {},
      rules: {},
      options: []
    });
    state.ruleFormBack = _.cloneDeep(state.ruleForm);
    // state.ruleForm
    const refData = toRefs(state);
    // 监听弹框显示因此
    watchEffect(() => {
      state.formVisible = props.modelValue;
      if (props.modelValue && props.status) {
        initForm();
      }
    });
    watchEffect(() => {
      context.emit('update:modelValue', state.formVisible);
    });
    // 初始化表单
    const initForm = async() => {
      const form = { ...state.ruleForm, ...props.form };
      form.nationality = [form.nationality];
      if (props.status === 2 || props.status === 4) {
        state.ruleForm = _.cloneDeep(form);
      }
      console.log("🚀333333 ~ line 414 ~ initForm ~ state.ruleForm", state.ruleForm);

      //
    };
    // 保存表单数据
    const submitForm = formEl => {
      state.ruleForm.nationality = state.ruleForm.nationality.toString();
      const newid = state.ruleForm.registerId;
      let aa = Array.isArray(newid);
      if (aa) {
        aa = newid.pop();
        state.ruleForm.registerId = aa;
      }
      console.log("state.ruleForm", state.ruleForm);

      if (!formEl) return;
      formEl.validate(async valid => {
        console.log(state.ruleForm);
        if (valid) {
          const form = _.cloneDeep(state.ruleForm);
          form.deptId = props.form.parentId;
          util.formatForm(form);
          let res;
          if (props.status === 1) {
            res = await saveQuery(form);
          } else if (props.status === 2) {
            res = await updateQuery(form);
            // res = form;
          } else if (props.status === 4) {
            res = await updateQuery(form);
            // res = form;
          }
          if (res.code === 0) {
            state.formVisible = false;
            ElMessage.success('操作成功');
            state.formVisible = false;
            context.emit('submit');
          }
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };
    const close = () => {
      state.ruleForm = _.cloneDeep(state.ruleFormBack);
    };
    // 禁用
    const isDisabled = computed(() => {
      return props.status === 3;
    });

    return {
      ...refData,
      submitForm,
      close,
      ruleFormRef,
      isDisabled
    };
  }
});
</script>
<style  lang='scss' scoped >
.userForm{
  width: 100%;
  max-height: 500px;
  overflow: auto;
}
.formTitle{
  display:flex;
  align-items: center;
  font-size:16px;
  font-weight: bold;
  margin-bottom: 10px;
  span{
    width: 3.5px;
    height: 16px;
    background-color: #5584ff;
    margin-right: 10px;
  }
}
.margLeftLabel{
  /deep/ .el-form-item__content{
    margin-left:0 !important;
  }
}
</style>